import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const RequiresAuth = ({ children }: PropsWithChildren) => {
  const { isAdmin, uid } = useAuth();

  if (!uid || !isAdmin) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};
